import {
  defaultRenderMessages,
  type MessageRenderer,
  type RenderMessagesOptions,
  type RenderedMessage,
} from 'stream-chat-react';
import type { LocalMessage } from 'stream-chat';
import { renderMessage } from './utils/renderCustomMessages';

export const customRenderMessagesWithClick = (onClick: (msg: LocalMessage) => void): MessageRenderer => {
  return (options: RenderMessagesOptions) => {
    const mappedMessages = options.messages.map((message) =>
      renderMessage(message as LocalMessage),
    ) as RenderedMessage[];
    const rendered = defaultRenderMessages({ ...options, messages: mappedMessages });

    return rendered.map((child, i) => (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      <div
        role="button"
        tabIndex={0}
        key={mappedMessages[i].id}
        onClick={() => onClick(mappedMessages[i] as LocalMessage)}
        className="cursor-pointer hover:bg-base-95 transition"
      >
        {child}
      </div>
    ));
  };
};
